module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("98Lwu"))).then(() => parcelRequire('d0iPb'));